<template>
<!-- Blogs -->
            <section class="blog-section">
                <div class="container">
                    <div class="section-heading text-center">
                        <img src="../../../assets/img/icons/heading.png" alt="" class="img-fluid">
                        <h2>Popular Fields</h2>
                        <p>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat </p>
                    </div>
                    <div class="row">
                        <div class="col-lg-4 col-md-6" v-for="item in fields" :key="item.id">
                            <div class="our-blogs">
                                <div class="blog-img">
                                    <img width="300" height="300" :src="getImageUrl(item)" alt="" class="">
                                </div>
                                <div class="blogs-date">
                                    <p>{{ item.stadiums.business_name }}</p>
                                </div>
                                <div class="blog-text mt-3">
                                    <h5><router-link to="/blog-details">{{ item.name }}</router-link></h5>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Tortor, nunc vulputate </p>
                                    <router-link to="/blog-details">Read more <i class='fas fa-arrow-right ms-1'></i></router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- /Blogs -->
</template>
<script>

import { api } from '@/store';
export default {
    created() {
    this.getPopularFields()
  },
  data() {
    return {
      fields: []
    }
  },
  methods: {
    getPopularFields(){
        api.get('/fields')
        .then(response => {
          const result = response.data
          this.fields = result
        })
    },
    getImageUrl(field) {
        return `/api/static/${field.field_image}.jpg`
    }
  }
}
</script>